module.exports = __webpack_public_path__ + "img/bg3.5960acc3.png";